// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"b6fb87d2","113":"cc9d0399","405":"15196cf1","426":"029693f9","582":"06f6dffe","626":"df7f67d2","793":"1b100574","969":"304378e6"}[chunkId] + ".chunk.css";
};